import { TransitionPageComponent } from './shared/transition-page/transition-page.component';
import { LocalizationGuard } from './localization-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomePageComponent } from './home-page/home-page.component';
import { OpenProjectComponent } from './open-project/open-project.component';
import { PageComponent } from './page/page.component';
import { RoomComponent } from './page/room/room.component';
import { SystemComponent } from './page/system/system.component';
import { InternalUnitComponent } from './page/internal-unit/internal-unit.component';
import { SmartCameraComponent } from './page/smart-camera/smart-camera.component';
import { SmartThermoComponent } from './page/smart-thermo/smart-thermo.component';
import { FinishingComponent } from './page/finishing/finishing.component';
import { PackageComponent } from './page/package/package.component';
import { TimeComponent } from './page/time/time.component';
import { WhatToDoComponent } from './page/what-to-do/what-to-do.component';
import { HavingLivingLightComponent } from './page/having-living-light/having-living-light.component';
import { CoverConfiguratorComponent } from './page/cover-configurator/cover-configurator.component';
import { FrameShapeComponent } from './page/frame-shape/frame-shape.component';
import { SummaryComponent } from './page/summary/summary.component';
import { SwitchComponent } from './page/switch/switch.component';
import { PrivacyComponent } from './page/privacy/privacy.component';
import { ThanksComponent } from './page/thanks/thanks.component';
import { ShareProjectComponent } from './share-project/share-project.component';
import { SummaryViewComponent } from './page/summary-view/summary-view.component';
import { SendQuotationComponent } from './page/send-quotation/send-quotation.component';
import { FindInstallerComponent } from './page/find-installer/find-installer.component';
import { RejectComponent } from './reject/reject.component';

const routes: Routes = [
  {
    path: "home",
    pathMatch: "full",
    component: HomePageComponent,
    data: { animation: 'HomePage' }
  },
  {
    path: "open",
    children: [{
      path: ':uuid',
      component: OpenProjectComponent,
    }, {
      path: '',
      component: OpenProjectComponent,
    }],
    //    pathMatch: "full",
    data: { animation: 'OpenProject' }
  },    
  {
    path: "share",
    children: [{
      path: ':uuid',
      component: ShareProjectComponent
    }, {
      path: '',
      component: ShareProjectComponent
    }]
  },
  {
    path: "summary-view",
    component: PageComponent,
    canActivateChild: [LocalizationGuard],
    children: [
      {
        path: "report",
        component: SummaryViewComponent
      },
      {
        path: "findinstaller",
        component: FindInstallerComponent
      },
      {
        path: "send",
        component: SendQuotationComponent
      }
    ]
  },
  {
    path: "summary-view/thanks",
    pathMatch: "full",
    component: ThanksComponent,
    data: { fromSummaryView: true } 
  },  
  {
    path: "wiz",
    component: PageComponent,
    canActivateChild: [LocalizationGuard],
    children: [
      {
        path: "transition",
        component: TransitionPageComponent
      },
      {
        path: "whattodo",
        component: WhatToDoComponent
      },
      {
        path: "havingbticino",
        component: HavingLivingLightComponent
      },
      {
        path: "rooms",
        component: RoomComponent
      },
      {
        path: "systems",
        component: SystemComponent
      },
      {
        path: "internalunit",
        component: InternalUnitComponent
      },
      {
        path: "smartthermo",
        component: SmartThermoComponent
      },       
      {
        path: "softsecurity",
        component: SmartCameraComponent
      },      
      {
        path: "finishing",
        component: FinishingComponent
      },
      {
        path: "frameshape",
        component: FrameShapeComponent
      },
      {
        path: "coverconfigurator",
        component: CoverConfiguratorComponent
      },
      {
        path: "packages",
        component: PackageComponent
      },
      {
        path: "switch",
        component: SwitchComponent
      },
      {
        path: "times",
        component: TimeComponent
      },
      {
        path: "summary",
        component: SummaryComponent
      },
      {
        path: "privacy",
        component: PrivacyComponent
      }
    ]
  },
  {
    path: "wiz/thanks",
    pathMatch: "full",
    component: ThanksComponent
  },
  {
    path: "",
    pathMatch: "full",
    component: HomePageComponent,
    data: { animation: 'HomePage'}
  },
  {
    path: "reject",
    children: [{
      path: ':token/:uuid',
      component: RejectComponent
    }, {
      path: '',
      component: RejectComponent
    }]
  },
  {
    path: "reject/thanks",
    pathMatch: "full",
    component: ThanksComponent,
    data: { fromReject: true } 
  }, 
  {
    path: "**",
    redirectTo: ""
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
